














import { PreCollectionsParams } from '@/resource/pre-collection/pre-collection.store';
import { Component, Prop, Vue } from 'vue-property-decorator';
import FilterDropdown from '@/main-components/pre-collections-new/pre-collection-filter/FilterDropdown.vue';

@Component({
  components: {
    FilterDropdown,
  },
})
export default class FilterYear extends Vue {
  @Prop({ required: true })
  queries!: PreCollectionsParams;

  @Prop({ required: true })
  filterReset: boolean;

  generateYears() {
    return [...Array(5).keys()].map(i => 2024 - i);
  }

  updateYears(years: number[]) {
    this.queries.years = years;
    this.$emit('submitFilter', true);
  }
}
